import {
  Button,
  CircularProgress,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  TextField,
  Typography,
} from '@material-ui/core';
import {getSicCodesByCaseNumber, updateSicCode} from 'BOSTools/ducks/bosTools';
import {InvalidSicCodeValue, SicCode, ValidSicCodeValue} from 'BOSTools/models/SicCode';
import {isLoaded, ServerError} from 'Core/models/Async';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import './BOSTools.sass';

const SicCodeUpdate = () => {
  const dispatch = useDispatch();

  const {sicCodes} = useSelector((state: ReducerState) => state.bostools);
  const [caseNumber, setCaseNumber] = useState(isLoaded(sicCodes) ? sicCodes.Data[0]?.caseNumber : '');
  const [selectedSicCode, setSelectedSicCode] = useState<SicCode>();

  useEffect(() => {
    if (isLoaded(sicCodes) && sicCodes.Data.length === 1) {
      setSelectedSicCode(sicCodes.Data[0]);
    }
  }, [sicCodes]);

  return (
    <Grid container direction="column" spacing={4}>
      <>
        <Grid item>
          <TextField
            id="caseNumber"
            fullWidth
            variant="outlined"
            label="Case Number"
            value={caseNumber}
            onChange={e => setCaseNumber(e.target.value)}
            required
          />
        </Grid>
        <Grid item container justify="flex-end">
          <Button
            color="primary"
            variant="contained"
            disabled={!caseNumber}
            onClick={() => {
              dispatch(getSicCodesByCaseNumber(caseNumber!));
              setSelectedSicCode(undefined);
            }}
          >
            Search
          </Button>
        </Grid>
        {isLoaded(sicCodes) ? (
          selectedSicCode ? (
            <>
              <Grid item>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Case Number"
                  value={selectedSicCode.caseNumber}
                  disabled
                />
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Description"
                  value={selectedSicCode.description}
                  disabled
                />
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="SIC Code"
                  inputProps={{maxLength: 4}}
                  required
                  value={selectedSicCode.sicCodeValue.value || ''}
                  onChange={e =>
                    setSelectedSicCode({...selectedSicCode, sicCodeValue: ValidSicCodeValue.create(e.target.value)})
                  }
                  error={selectedSicCode.sicCodeValue instanceof InvalidSicCodeValue}
                  helperText={
                    selectedSicCode.sicCodeValue instanceof InvalidSicCodeValue &&
                    selectedSicCode?.sicCodeValue.validationError
                  }
                />
              </Grid>
              <Grid item container justify="flex-end">
                <Button
                  color="primary"
                  variant="contained"
                  disabled={selectedSicCode.sicCodeValue instanceof InvalidSicCodeValue}
                  onClick={() => dispatch(updateSicCode(selectedSicCode))}
                >
                  Update
                </Button>
              </Grid>
            </>
          ) : (
            <List
              subheader={
                <ListSubheader component="div" disableSticky>
                  Please Choose An Item From The List To Update
                </ListSubheader>
              }
            >
              <Divider component="hr" />
              {sicCodes.Data.map(sc => (
                <ListItem key={sc.groupID} button onClick={() => setSelectedSicCode(sc)}>
                  <ListItemText
                    primary={
                      <Grid container>
                        <Grid item>
                          <Typography className="bostools_right_margin">SIC Code: {sc.sicCodeValue.value}</Typography>
                        </Grid>
                        <Grid item>
                          <Typography variant="body1">Description: {sc.description}</Typography>
                        </Grid>
                      </Grid>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )
        ) : sicCodes.key === 'Loading' ? (
          <div className="bostools_form__loading-container">
            <CircularProgress color="primary" />
          </div>
        ) : (
          ['ServerError', 'NotFound'].includes(sicCodes.key) && (
            <Grid item>
              <Typography variant="body1">
                {(sicCodes as ServerError).errorDetails || (sicCodes as ServerError).message}
              </Typography>
            </Grid>
          )
        )}
      </>
    </Grid>
  );
};

export default SicCodeUpdate;
